import Button from '@atlaskit/button';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import React, { useCallback, useState } from 'react';

interface ResetMappingsProps {
  isDisabled: boolean;
  onResetMappings: VoidFunction;
}

export function ResetMappingsDialog({
  isDisabled,
  onResetMappings,
}: ResetMappingsProps) {
  const [isOpen, setIsOpen] = useState(false);
  const onOpenModal = useCallback(() => setIsOpen(true), []);
  const onCloseModal = useCallback(() => setIsOpen(false), []);

  function onConfirm() {
    onResetMappings();
    onCloseModal();
  }

  return (
    <>
      <Button isDisabled={isDisabled} onClick={onOpenModal}>
        Reset mapping
      </Button>
      <ModalTransition>
        {isOpen && (
          <Modal>
            <ModalHeader>
              <ModalTitle appearance="warning">
                Reset Projects Mappings
              </ModalTitle>
            </ModalHeader>
            <ModalBody>
              Resetting all projects mappings will undo any custom
              configurations. Confirm to proceed with the reset.
            </ModalBody>
            <ModalFooter>
              <Button appearance="subtle" onClick={onCloseModal}>
                Cancel
              </Button>
              <Button appearance="warning" onClick={onConfirm}>
                Confirm
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    </>
  );
}
